import { render } from "./ConfirmPassword.vue?vue&type=template&id=5707afdd&scoped=true"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js"

import "./ConfirmPassword.vue?vue&type=style&index=0&id=5707afdd&scoped=true&lang=css"

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5707afdd"]])

export default __exports__